"use strict";

import { from, of, take } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import {
    mergeMap,
    catchError,
    map,
    concatMap,
    merge,
    takeUntil,
} from "rxjs/operators";

import {
    ajaxError,
    shopTopPicksComplete,
    shopFavouritesComplete,
    shopTrendingsComplete,
    shopVoucherDetailsComplete,
    shopConfirmOrderComplete,
    shopVoucherWalletComplete,
    shopOrderDetailsComplete,
    shopBrowseProductsComplete,
    shopBrowseProductsCategoryComplete,
    shopBrowseProductsPopularFilterComplete,
    shopConfirmOrderRequest,
    showPopup,
    shopVoucherRedeemComplete,
    shopRateVoucherComplete,
    getUserPointsBalanceRequest,
    shopTLCGetPointBalanceComplete,
    shopTLCRebatePointsComplete,
    shopTLCGetPointBalanceRequest,
    ajaxSuccess,
} from "../_actions";
import {
    shopConstants,
    requestTypes,
    authConstants,
    commonConstants,
} from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";
import { StripePaymentNextStep } from "../_constants/shop.constants";

export const getShopTopPicksEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.TOP_PICKS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/shop/top-picks",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return shopTopPicksComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getShopTrendingsEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.TRENDINGS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/shop/trendings",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return shopTrendingsComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getShopFavouritesEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.FAVOURITES_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/shop/favourites",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return shopFavouritesComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getShopVoucherDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.VOUCHER_DETAILS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/shop/voucher-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return shopVoucherDetailsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const shopConfirmOrderEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.CONFIRM_ORDER_REQUEST),
        mergeMap((action) => {
            const { navigate, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/shop/order-confirm",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    // map((ajaxResponse) => {
                    //     if (ajaxResponse.response.data) {
                    //         navigate("/app/shop/voucher-wallet");
                    //     } else {
                    //         return ajaxError({
                    //             response: {
                    //                 message:
                    //                     "Sorry, You don't have enough points to by this voucher ",
                    //                 statusCode: "333",
                    //             },
                    //         });
                    //     }
                    //     return shopConfirmOrderComplete(ajaxResponse.response);
                    // }),
                    concatMap((ajaxResponse) => {
                        if (ajaxResponse.response.data) {
                            navigate("/app/shop/voucher-wallet");
                        } else {
                            return ajaxError({
                                response: {
                                    message:
                                        "Sorry, You don't have enough points to by this voucher ",
                                    statusCode: "333",
                                },
                            });
                        }

                        return of(
                            getUserPointsBalanceRequest(),
                            shopConfirmOrderComplete(ajaxResponse.response),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getShopOrderDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.ORDER_DETAILS_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/shop/order-details/" + action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return shopOrderDetailsComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getShopVoucherWalletEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.VOUCHER_WALLET_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/shop/voucher-wallet/",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return shopVoucherWalletComplete({
                            ...ajaxResponse.response,
                            pollSessionId: action.payload?.pollSessionId,
                        });
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getShopBrowserProductsEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.BROWSE_PRODUCTS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/shop/browse-products",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return shopBrowseProductsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getShopPopularFilterEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.BROWSE_PRODUCTS_POPULAR_FILTER_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/shop/popular-filters",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return shopBrowseProductsPopularFilterComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getShopCategoryEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.BROWSE_PRODUCTS_CATEGORY_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/shop/category",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return shopBrowseProductsCategoryComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const shopBuyPointsEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.BUY_POINTS_REQUEST),
        mergeMap((action) => {
            const { navigate, voucherDetails, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/shop/buy-points",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        if (
                            ajaxResponse?.response?.nextAction ===
                            StripePaymentNextStep.REDIRECT
                        ) {
                            const popupData = {
                                type: "iframe",
                                iframeSrc: ajaxResponse?.response?.redirectUrl,
                                iframeAttributes: {
                                    width: "100%",
                                    height: "600px",
                                },
                                intentId: ajaxResponse?.response?.intentId,
                            };
                            return of(showPopup(popupData));
                        } else if (
                            ajaxResponse?.response?.status === "success"
                        ) {
                            const order = {
                                voucherId: voucherDetails.id,
                                participantPoints: 0,
                                cashTopUp: 0,
                                topUpPoints: 0,
                                voucherPoints: 0,
                                voucherValue: voucherDetails.voucherByValue,
                                paymentIntent: ajaxResponse?.response?.intentId,
                                navigate,
                            };

                            return of(shopConfirmOrderRequest(order));
                        } else {
                            return of(
                                ajaxError({
                                    response: {
                                        message:
                                            "Payment failed. Please check the card details.",
                                        statusCode: "333",
                                    },
                                }),
                            );
                        }
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const setVoucherRedeemStatusEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.REDEEM_VOUCHER_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/shop/redeem-voucher/" + action.payload.id,
                    null,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        if (ajaxResponse.response.data) {
                            return shopVoucherRedeemComplete(action.payload.id);
                        } else {
                            return ajaxError({
                                response: {
                                    message: "Redemption status set failed.",
                                    statusCode: "333",
                                },
                            });
                        }
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const shopRateVoucherEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.RATE_VOUCHER_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/shop/rate-voucher",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        if (ajaxResponse.response.data) {
                            return shopRateVoucherComplete(action.payload);
                        } else {
                            return of(
                                ajaxError({
                                    response: {
                                        message: "Rate voucher set failed.",
                                        statusCode: "333",
                                    },
                                }),
                            );
                        }
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const shopTLCGetPointBalanceEpic = (actions$) =>
    actions$.pipe(
        ofType(shopConstants.SHOP_TLC_GET_POINT_BALANCE_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/shop/shopTLCGetPointBalance",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return shopTLCGetPointBalanceComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );

export const shopTLCRebatePointsEpic = (actions$) => {
    return actions$.pipe(
        ofType(shopConstants.SHOP_TLC_REBAT_POINTS_REQUEST),
        mergeMap((action) => {
            const { navigate, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/shop/shopTLCRebatePoints",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        navigate('/app/points-banking')
                        return of(
                             getUserPointsBalanceRequest(),
                             shopTLCGetPointBalanceRequest(),
                             shopTLCRebatePointsComplete(
                                ajaxResponse.response,
                             ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};
